import React, { useState } from 'react'
import floorDict from '../floorDict.json'

const FloorSelect = ({ activeFloor, setActiveFloor }) => {
  const [isOpen, setOpen] = useState(false)
  const floorEntry = Object.entries(floorDict).find(([_, mapId]) => mapId === activeFloor)
  const activeFloorName = floorEntry ? floorEntry[0].split('_').join(' ') : 'All Floors'

  const changeFloor = (f) => {
    setOpen(false)
    setActiveFloor(f)
  }

  return (
    <div className='floorSelect'>
      <div className='selectedValue' onClick={() => setOpen(!isOpen)}>
        <span>{activeFloorName}</span>
        <span>{isOpen ? '▲' : '▼'}</span>
      </div>
      {isOpen ? (<div className='dropdown'>
        <div className='option' onClick={() => setActiveFloor('')}>All Floors</div>
      {Object.entries(floorDict).map(([cmsId, mapId]) => (
        <div className='option' value={mapId} key={mapId} onClick={() => changeFloor(mapId)}>{cmsId.split('_').join(' ')}</div>
      ))}
      </div>) : null}
    </div>
  )
}

export default FloorSelect